/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The authentication methods that are supported by the server, each user
 * may be allowed to authenticate via one or more of these methods.
 */
export var UserAuthMethod;
(function (UserAuthMethod) {
    UserAuthMethod["PASSWORD"] = "password";
    UserAuthMethod["TOKEN"] = "token";
})(UserAuthMethod || (UserAuthMethod = {}));
